/**
 * TRW Cookie Consent Functions
 * Cookie consent modal handling for OXID frontend
 *
 * Vanilla JS implementation (OXID 7.4+ ready)
 *
 * @author  Mario Lorenz, www.the-real-world.de
 * @license https://www.gnu.org/licenses/gpl-2.0.html GNU General Public License, version 2 (one or other)
 */

/**
 * Read the raw value of the consent cookie.
 *
 * @return {string|undefined}
 */
function getConsentCookieValue() {
    const cookieRow = document.cookie.split('; ').find(row => row.startsWith('trwcookieconsentallowedcookies='));
    return cookieRow ? cookieRow.split('=')[1] : undefined;
}

/**
 * Initialize the Cookie Consent functionality.
 * Called automatically on DOMContentLoaded.
 *
 * @return {void}
 */
export function init() {
    const $oAdjustSettings = document.getElementById("adjust-cookieconsent-settings");
    const $oNote = document.getElementById("cookieconsent-note");
    const $oOnlyNecessary = document.getElementById("select-only-necessary");
    const $oAll = document.getElementById("select-all");
    const $oHideSettings = document.getElementById("hide-cookieconsent-settings");
    const $oWelcome = document.getElementById("cookieconsent-welcometext");
    const $oAccordion = document.getElementById("cookieconsent-accordion");
    const $oNotNecessary = document.querySelectorAll(".cookieconsent-not-necessary");
    const $oSaveSelection = document.getElementById("save-cookieconsent-selection");
    const $oForm = document.getElementById("cookieconsent-form");
    const $oOpenPopup = document.querySelectorAll(".btn-cookieconsent");

    // Check if required elements exist
    if (!$oNote || !$oForm) return;

    const cookieValue = getConsentCookieValue();

    const bsModal = new bootstrap.Modal($oNote, {
        backdrop: 'static',
        keyboard: false
    });

    $oOpenPopup.forEach(button => {
        button.addEventListener('click', () => {
            bsModal.show();
        });
    });

    if (cookieValue && cookieValue !== 'undefined') {
        $oOpenPopup.forEach(button => {
            button.classList.add("show");
        });
    } else {
        if ($oOpenPopup.length > 0) {
            $oOpenPopup[0].click();
        }
    }

    if ($oAdjustSettings) {
        $oAdjustSettings.addEventListener('click', function () {
            this.style.display = "none";
            if ($oOnlyNecessary) $oOnlyNecessary.style.display = "inline-block";
            if ($oSaveSelection) $oSaveSelection.style.display = "inline-block";
            if ($oAll) $oAll.style.display = "none";
            if ($oHideSettings) $oHideSettings.style.display = "inline-block";
            if ($oWelcome) $oWelcome.style.display = "none";
            if ($oAccordion) $oAccordion.style.display = "block";
        });
    }

    if ($oAll) {
        $oAll.addEventListener('click', function () {
            $oNotNecessary.forEach(el => el.checked = true);
            if ($oSaveSelection) $oSaveSelection.click();
        });
    }

    if ($oOnlyNecessary) {
        $oOnlyNecessary.addEventListener('click', function () {
            $oNotNecessary.forEach(el => el.checked = false);
            if ($oSaveSelection) $oSaveSelection.click();
        });
    }

    if ($oHideSettings) {
        $oHideSettings.addEventListener('click', function () {
            this.style.display = "none";
            if ($oOnlyNecessary) $oOnlyNecessary.style.display = "none";
            if ($oAdjustSettings) $oAdjustSettings.style.display = "inline-block";
            if ($oSaveSelection) $oSaveSelection.style.display = "none";
            if ($oAll) $oAll.style.display = "inline-block";
            if ($oAccordion) $oAccordion.style.display = "none";
            if ($oWelcome) $oWelcome.style.display = "block";
        });
    }

    if ($oSaveSelection) {
        $oSaveSelection.addEventListener('click', function (e) {
            e.preventDefault();

            const formData = new FormData($oForm);
            const sConsentBefore = getConsentCookieValue();

            fetch($oForm.action, {
                method: 'POST',
                body: new URLSearchParams(formData)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.text();
                })
                .then(data => {
                    // Server-side checks (oViewConf.isAllowedCookie()) only see the
                    // new consent on the next request: reload if it actually changed.
                    if (getConsentCookieValue() !== sConsentBefore) {
                        window.location.reload();
                        return;
                    }
                    bsModal.hide();
                    $oOpenPopup.forEach(button => {
                        button.classList.add("show");
                    });
                })
                .catch(error => {
                    console.error('Error when saving the cookie settings: ', error);
                    bsModal.hide();
                });
        });
    }
}

// Auto-initialize on DOMContentLoaded
if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        // DOM already loaded
        init();
    }
}
